<template>
    <div class="home">
      <Logo />
      <NavBar />
    </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import NavBar from "@/components/NavBar.vue";

export default {
  name: "home",
  components: {
    NavBar,
    Logo
  }
};
</script>

<style lang="scss" scoped>
.home {
  text-align: center;
}

.logo {
  margin-bottom: 20px;
}
</style>
